import { useBackgroundOutbox } from '../lib/tripSync.ts'
import { Outlet } from 'react-router-dom'
import { useDesktop } from '../lib/useDesktop.ts'
import { Sidebar } from './Sidebar.tsx'

/** Na pocitaci stoji vlevo bocni panel a obsah vedle nej; na telefonu jen obsah. */
export function AppLayout() {
  const desktop = useDesktop()
  // Fronty nakupu, ktere nejsou otevrene (Hotovo bez signalu), odejdou samy.
  useBackgroundOutbox()
  if (!desktop) return <Outlet />
  return (
    <div className="desk">
      <Sidebar />
      <div className="desk-main">
        <Outlet />
      </div>
    </div>
  )
}
